import { useContext } from "react";

import { IDynamicFormItemProps } from ".";

import MultipleCheckboxInput from "components/MultipleCheckboxInput/MultipleCheckboxInput";

import c from "classnames";

import { DynamicFormContext } from "../DynamicFormContext";

export function MultiSelectInputItem({ item }: IDynamicFormItemProps<"inputMultiSelect">) {
  const { form } = useContext(DynamicFormContext);

  const { content, key } = item;
  const { options } = content;
  const { value } = form.getFormInput(key);

  const classes = c("dynamic-form-item form-item--input-multi-select");

  const inputOptions = options.map(option => {
    return {
      id: option.key || option.label,
      label: option.label,
      value: option.value,
    };
  });

  return (
    <MultipleCheckboxInput
      className={classes}
      dataTestId={true}
      dividers
      id={key}
      onChange={form.onChange}
      options={inputOptions}
      value={value as string[] | undefined}
    />
  );
}
